import { useOrganization } from "@customer-app/account/views/OperationAquarius/utils";
import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";
import { LDContext, useLDClient } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
export const useLDIdentityCustomer = (): LDContext | null => {
  const customerRelationship = useSmartrrCustomerSelector(state => state.auth.customerRelationship);
  const organization = useOrganization();
  const ldClient = useLDClient();

  return useMemo(() => {
    if (!organization) {
      return null;
    }

    const { orgName, myShopifyDomain, id: organizationId } = organization;
    return {
      kind: "multi",
      customer: {
        key: organizationId, // To prevent overloading our LD MAU limit, customers of an organization will share the same key
        anonymous: true,
        isSuperUser: customerRelationship?.isSuperUser ?? false,
      },
      organization: {
        key: organizationId,
        orgName,
        myShopifyDomain,
      },
    };
  }, [customerRelationship, ldClient, organization]);
};
